import {
    get_datiUserInfo,
    update_profilo,
    cambia_password,
} from "@/api/api.user.js";

const user = {
    namespaced: true,

    state: {
        user: '',
        role: '',
        mail: '',
        displayName: '',
        menu: [],
    },

    mutations: {
        SET_USER: (state, user) => {

            state.user = user.username
            state.role = user.role
            state.menu = user.menu
            state.mail = user.eMail
            state.displayName = user.displayName
        },
    },

    actions: {

        userInfo({
            commit
        }) {

            return new Promise((resolve, reject) => {

                get_datiUserInfo().then(resp => {

                    commit("SET_USER", resp.data)

                    resolve(resp)

                }).catch(err => {

                    reject(err)
                })
            })

        },

        // Aggiorna email/nome visualizzato, poi ricarica userInfo per tenere lo
        // state coerente (stesso pattern usato altrove: dispatch che si appoggia
        // sulla action già esistente invece di duplicare la logica di commit).
        aggiornaProfilo({ dispatch }, dati) {
            return new Promise((resolve, reject) => {
                update_profilo(dati).then(resp => {
                    dispatch("userInfo").then(() => resolve(resp)).catch(() => resolve(resp))
                }).catch(err => reject(err))
            })
        },

        cambiaPassword(_context, dati) {
            return new Promise((resolve, reject) => {
                cambia_password(dati).then(resp => resolve(resp)).catch(err => reject(err))
            })
        },

    },

    getters: {
        getRole: state => state.role,

        getNome: state => {
            return state.user
        },
        getMail: state => {
            return state.mail
        },
        getDisplayName: state => {
            return state.displayName
        },
    }
}


export default user
